<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :loading="modalLoading"
      :data="queryDatabaseByApplicationIdList"
      style="width: 100.1%;"
    >
      <template slot-scope="{ row, index }" slot="actions">
        <Button type="info" size="small" @click="databaseDetail(row)"
          >{{ $t('aiMonitor.detail') }}</Button
        >
        <span @click="doDelete(index)">
          <!-- <Button type="info" size="small" @click="configurationWeight(row)">配置权重</Button> -->
          <Button type="info" size="small" @click="handleShowMonitorIndex(row)"
            >{{ $t('aiMonitor.configMonitorIndex') }}</Button
          >
          <Button type="error" size="small" @click="databaseDelModal = true">{{
            $t("alarms.common.delete")
          }}</Button>
        </span>
      </template>
    </Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>

    <Modal v-model="databaseDelModal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ Name }}
          {{ $t("alarms.common.what") }}?
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          @click="deleteDatabase()"
          :disabled="isDisable"
          >{{ $t("alarms.common.delete") }}
        </Button>
      </div>
    </Modal>

    <Modal
      v-model="configurationWeightModal"
      :title="$t('aiMonitor.configWeight')"
      :loading="loading"
      :mask-closable="false"
    >
      <Form
        ref="weightForm"
        :model="weightForm"
        :label-width="110"
        :rules="ruleValidate"
      >
        <!-- 数据库权重 -->
        <FormItem :label="$t('aiMonitor.databaseWeight')" prop="instanceWeight">
          <InputNumber
            :max="100"
            :min="1"
            v-model="weightForm.instanceWeight"
            style="width:100%;"
          ></InputNumber>
        </FormItem>

        <Row :gutter="16">
          <!-- CPU使用率 -->
          <Col span="12">
            <FormItem :label="$t('aiMonitor.cpuUsageWeight')" prop="cpuUsage">
              <InputNumber
                :max="100"
                :min="1"
                v-model="weightForm.cpuUsage"
                style="width:100%;"
              ></InputNumber>
            </FormItem>
          </Col>
          <!-- 拟合度 -->
          <Col span="12">
            <FormItem :label="$t('aiMonitor.fitting')" prop="cpuFitting">
              <InputNumber
                :max="1"
                :min="0"
                v-model="weightForm.cpuFitting"
                style="width:100%;"
              ></InputNumber>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="16">
          <!-- 可用内存 -->
          <Col span="12">
            <FormItem :label="$t('aiMonitor.memoryAvailableWeight')" prop="memoryAvailable">
              <InputNumber
                :max="100"
                :min="1"
                v-model="weightForm.memoryAvailable"
                style="width:100%;"
              ></InputNumber>
            </FormItem>
          </Col>
          <!-- 拟合度 -->
          <Col span="12">
            <FormItem :label="$t('aiMonitor.fitting')" prop="memoryAvailableFitting">
              <InputNumber
                :max="1"
                :min="0"
                v-model="weightForm.memoryAvailableFitting"
                style="width:100%;"
              ></InputNumber>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="16">
          <!-- 读IOPS -->
          <Col span="12">
            <FormItem :label="$t('aiMonitor.readIopsWeight')" prop="readIops">
              <InputNumber
                :max="100"
                :min="1"
                v-model="weightForm.readIops"
                style="width:100%;"
              ></InputNumber>
            </FormItem>
          </Col>
          <!-- 拟合度 -->
          <Col span="12">
            <FormItem :label="$t('aiMonitor.fitting')" prop="readIopsFitting">
              <InputNumber
                :max="1"
                :min="0"
                v-model="weightForm.readIopsFitting"
                style="width:100%;"
              ></InputNumber>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="16">
          <!-- 写IOPS -->
          <Col span="12">
            <FormItem :label="$t('aiMonitor.writeIopsWeight')" prop="writeIops">
              <InputNumber
                :max="100"
                :min="1"
                v-model="weightForm.writeIops"
                style="width:100%;"
              ></InputNumber>
            </FormItem>
          </Col>
          <!-- 拟合度 -->
          <Col span="12">
            <FormItem :label="$t('aiMonitor.fitting')" prop="writeIopsFitting">
              <InputNumber
                :max="1"
                :min="0"
                v-model="weightForm.writeIopsFitting"
                style="width:100%;"
              ></InputNumber>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button @click="caseReset('weightForm')">{{ $t('alarms.common.cancel') }}</Button>
        <Button type="primary" @click="caseSubmit('weightForm')">{{ $t('aiMonitor.update') }}</Button>
      </div>
    </Modal>

    <Modal
      v-model="ShowMonitorIndexModal"
      :title="$t('aiMonitor.configMonitorIndex')"
      :loading="loading"
      :mask-closable="false"
      width="750"
    >
      <Form ref="MonitorIndexForm" :model="MonitorIndexForm" :label-width="110">
        <FormItem :label="$t('aiMonitor.monitorIndex')" prop="MonitorIndex">
          <Select
            filterable
            v-model="MonitorIndexForm.metricIndex"
            style="width:300px;"
            label-in-value
            @on-change="handleSelectMonitorIndex"
          >
            <Option
              v-for="item in MonitorIndexList"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
          <Button
            type="primary"
            style="margin-left:20px"
            @click="handleAddMonitorIndex"
            >{{ $t('alarms.common.add') }}</Button
          >
        </FormItem>
        <div
          v-for="(item, index) in MonitorIndexForm.MonitorIndexArr"
          :key="item.id"
        >
          <Row :gutter="4">
            <Col span="10">
              <FormItem :label="$t('aiMonitor.monitorIndex')">
                <Input
                  v-model="item.metricName"
                  style="width:180px"
                  disabled
                ></Input> </FormItem
            ></Col>
            <Col span="10">
              <FormItem :label="$t('aiMonitor.alertThreshold')">
                <Input
                  v-model="item.metricThresholdValue"
                  style="width:180px; "
                ></Input> </FormItem
            ></Col>
            <Col span="4">
              <FormItem label="" :label-width="30">
                <Button type="error" @click="handleDelMonitorIndex(index)"
                  >{{ $t('alarms.common.delete') }}</Button
                >
              </FormItem>
            </Col>
          </Row>
        </div>
      </Form>
      <div slot="footer">
        <Button @click="caseResetMonitorIndex('ruleValidateMonitorIndexForm')"
          >{{ $t('alarms.common.cancel') }}</Button
        >
        <Button
          type="primary"
          @click="caseSubmitMonitorIndex('ruleValidateMonitorIndexForm')"
          >{{ $t('common.determine') }}</Button
        >
      </div>
    </Modal>
  </div>
</template>
<script>
var tableDatabases = {};
export default {
  name: "TableDatabases",
  data() {
    return {
      MonitorIndexForm: {
        metricIndex: "",
        MonitorIndexArr: []
      },
      MonitorIndexList: [
        { id: "21", name: this.$t('aiMonitor.metrics.rdsCpuUsage') },
        { id: "22", name: this.$t('aiMonitor.metrics.rdsMemoryUsage') },
        { id: "23", name: this.$t('aiMonitor.metrics.rdsDiskSpaceUsage') },
        { id: "24", name: this.$t('aiMonitor.metrics.rdsDatabaseConnections') },
        { id: "25", name: this.$t('aiMonitor.metrics.rdsReadIops') },
        { id: "26", name: this.$t('aiMonitor.metrics.rdsWriteIops') }
      ],
      ShowMonitorIndexModal: false,
      id: "",
      loading: true,
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      Name: "",
      modalLoading: true,
      databaseDelModal: false,
      isDisable: false,
      configurationWeightModal: false,
      weightForm: {
        instanceWeight: null,
        cpuUsage: null,
        cpuFitting: null,
        memoryAvailable: null,
        memoryAvailableFitting: null,
        readIops: null,
        readIopsFitting: null,
        writeIops: null,
        writeIopsFitting: null
      },
      ruleValidate: {
        instanceWeight: [
          {
            required: true,
            message: this.$t('aiMonitor.enterDatabaseWeight'),
            trigger: "blur",
            type: "number"
          }
        ],
        cpuUsage: [
          {
            required: true,
            message: this.$t('aiMonitor.enterCpuUsageWeight'),
            trigger: "blur",
            type: "number"
          }
        ],
        cpuFitting: [
          {
            required: true,
            message: this.$t('aiMonitor.enterFitting'),
            trigger: "blur",
            type: "number"
          }
        ],
        memoryAvailable: [
          {
            required: true,
            message: this.$t('aiMonitor.enterMemoryAvailableWeight'),
            trigger: "blur",
            type: "number"
          }
        ],
        memoryAvailableFitting: [
          {
            required: true,
            message: this.$t('aiMonitor.enterFitting'),
            trigger: "blur",
            type: "number"
          }
        ],
        readIops: [
          {
            required: true,
            message: this.$t('aiMonitor.enterReadIopsWeight'),
            trigger: "blur",
            type: "number"
          }
        ],
        readIopsFitting: [
          {
            required: true,
            message: this.$t('aiMonitor.enterFitting'),
            trigger: "blur",
            type: "number"
          }
        ],
        writeIops: [
          {
            required: true,
            message: this.$t('aiMonitor.enterWriteIopsWeight'),
            trigger: "blur",
            type: "number"
          }
        ],
        writeIopsFitting: [
          {
            required: true,
            message: this.$t('aiMonitor.enterFitting'),
            trigger: "blur",
            type: "number"
          }
        ]
      },
      state: [
        "creating",
        "available",
        "stopping",
        "stopped",
        "shutting down",
        "terminated",
        "running"
      ],
      columns: [
        {
          title: this.$t("alarms.database.name"),
          key: "name"
        },
        {
          title: this.$t("alarms.database.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("alarms.database.databaseId"),
          key: "databaseId"
        },
        {
          title: this.$t("alarms.database.engine"),
          key: "engine"
        },
        {
          title: this.$t("alarms.database.instanceType"),
          key: "type"
        },
        {
          title: this.$t("alarms.database.state"),
          key: "stateName"
        },
        {
          title: this.$t("alarms.database.region"),
          key: "region"
        },
        {
          title: this.$t("common.operation"),
          width: 240,
          slot: "actions"
        }
      ],
      queryDatabaseByApplicationIdList: []
    };
  },
  beforeCreate: function() {
    tableDatabases = this;
  },
  mounted: function() {
    tableDatabases.queryDatabasesByApplicationId();
  },
  methods: {
    handleShowMonitorIndex(row) {
      this.ShowMonitorIndexModal = true;
      this.id = row.id;
      var lineIndex = this.lineIndex;
      this.$api.applicationDatabaseRelation
        .selectWeightByApplicationIdAndDatabaseId({
          applicationId: this.$route.query.id,
          alertRuleName: this.$route.query.alertRuleName,
          databaseId: row.id
        })
        .then(res => {
          this.MonitorIndexForm.MonitorIndexArr =
            res.data.aiApplicationMetricThresholdDTOS;
          let arr = [];
          this.MonitorIndexForm.MonitorIndexArr.forEach(item => {
            let data = {
              metricThresholdValue: item.thresholdValue,
              metricName: item.metricsName,
              metricIndex: item.metricsId
            };
            arr.push(data);
          });
          this.MonitorIndexForm.MonitorIndexArr = arr;
        });
    },
    caseSubmitMonitorIndex() {
      this.$api.applicationDatabaseRelation
        .updateDatabaseWeight({
          applicationId: this.$route.query.id,
          databaseId: this.id,
          alertRuleName: this.$route.query.alertRuleName,
          aiMetrics: this.MonitorIndexForm.MonitorIndexArr
        })
        .then(res => {
          this.$Message.success(this.$t('common.operationSuccess'));
          this.ShowMonitorIndexModal = false;
        });
    },
    handleAddMonitorIndex(name) {
      this.MonitorIndexForm.MonitorIndexArr.push({
        metricIndex: this.getItem.value,
        metricName: this.getItem.label,
        metricThresholdValue: ""
      });
    },
    handleDelMonitorIndex(index) {
      this.MonitorIndexForm.MonitorIndexArr.splice(index, 1);
    },
    handleSelectMonitorIndex(item) {
      console.log(item);
      this.getItem = item;
    },
    caseResetMonitorIndex(name) {
      this.ShowMonitorIndexModal = false;
      this.MonitorIndexForm.MonitorIndexArr = [];
      this.$refs[name].resetFields();
    },
    // 数据库列表
    queryDatabasesByApplicationId: function() {
      tableDatabases.$api.rds
        .pageRDSByApplicationId({
          applicationId: this.$route.query.id,
          alertRuleName: this.$route.query.alertRuleName,
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          this.modalLoading = false;
          this.queryDatabaseByApplicationIdList = res.data.records;

          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        })
        .catch(res => {
          // 如果列表里没数据 返回
          this.queryDatabaseByApplicationIdList = undefined;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableDatabases.queryDatabasesByApplicationId();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableDatabases.queryDatabasesByApplicationId();
    },
    // 显示所有数据
    showAllDatabase: function() {
      tableDatabases.queryDatabasesByApplicationId();
    },
    doDelete: function(index) {
      this.lineIndex = index;
      this.Name = this.queryDatabaseByApplicationIdList[index].name;
    },
    // 删除database
    deleteDatabase: function() {
      this.isDisable = true; // 开始可以点击
      var lineIndex = this.lineIndex;
      // 删除实例
      tableDatabases.$api.applicationDatabaseRelation
        .deleteApplicationDatabaseRelation({
          alertRuleName: this.$route.query.alertRuleName,
          applicationId: this.$route.query.id,
          databaseId: this.queryDatabaseByApplicationIdList[lineIndex].id
        })
        .then(res => {
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            //21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableDatabases.queryDatabasesByApplicationId();
            this.isDisable = false;
            this.databaseDelModal = false;
            this.$Message.success(this.$t('common.deleteSuccess'));
          }, 1000);
        });
    },
    // 数据库详情
    databaseDetail: function(row) {
      this.$router.push({
        path: "/aiMonitor/databaseDetail/",
        query: { databaseId: row.id }
      });
    },
    // 点击配置权重
    configurationWeight: function(row) {
      this.id = row.id;
      this.configurationWeightModal = true;
      var lineIndex = this.lineIndex;
      this.$api.applicationDatabaseRelation
        .selectWeightByApplicationIdAndDatabaseId({
          applicationId: this.$route.query.id,
          databaseId: row.id
        })
        .then(res => {
          // 数据库权重
          this.weightForm.instanceWeight = res.data.weightValue;
          // cpu使用率权重
          this.weightForm.cpuUsage = res.data.cpuUsageWeightValue;
          // cpu使用率拟合度
          this.weightForm.cpuFitting = res.data.cpuUsageFittingValue;
          // 可用内存权重
          this.weightForm.memoryAvailable = res.data.memoryAvailableWeightValue;
          // 可用内存拟合度
          this.weightForm.memoryAvailableFitting =
            res.data.memoryAvailableFittingValue;
          // 写IOPS权重
          this.weightForm.writeIops = res.data.writeIopsWeightValue;
          // 写IOPS拟合度
          this.weightForm.writeIopsFitting = res.data.writeIopsFittingValue;
          // 读IOPS权重
          this.weightForm.readIops = res.data.readIopsWeightValue;
          // 读IOPS拟合度
          this.weightForm.readIopsFitting = res.data.readIopsFittingValue;
        });
    },
    // 编辑
    /*************************************************************************/
    // 确定
    caseSubmit: function(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$api.applicationDatabaseRelation
            .updateInstanceWeight({
              applicationId: this.$route.query.id,
              databaseId: this.id,
              weightValue: this.weightForm.instanceWeight,
              cpuUsageWeightValue: this.weightForm.cpuUsage,
              cpuUsageFittingValue: this.weightForm.cpuFitting,
              memoryAvailableWeightValue: this.weightForm.memoryAvailable,
              memoryAvailableFittingValue: this.weightForm
                .memoryAvailableFitting,
              writeIopsWeightValue: this.weightForm.writeIops,
              writeIopsFittingValue: this.weightForm.writeIopsFitting,
              readIopsWeightValue: this.weightForm.readIops,
              readIopsFittingValue: this.weightForm.readIopsFitting
            })
            .then(res => {
              this.data = res.data;
              setTimeout(() => {
                this.$refs[name].resetFields();
                this.loading = false;
                this.$nextTick(() => {
                  this.loading = true;
                });
                this.$Message.success(this.$t('common.editSuccess'));
                this.configurationWeightModal = false;
              }, 1000);
            });
        } else {
          //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
          this.loading = false;
          setTimeout(() => {
            this.loading = true;
          }, 0);
          this.$Message.error(this.$t('common.editFail'));
        }
      });
    },
    // 取消
    caseReset: function(name) {
      this.configurationWeightModal = false;
      this.$refs[name].resetFields();
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ai_monitor/application_configuration/TableDatabases.vue